import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form } from "react-bootstrap";
import SelectDropDown from '../../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTableWithOutSearch from '../../datatables/CardLessDataTableWithOutSearch';
import moment from "moment";
import StudentsModal from './studentsModal'
import NotificationModal from './notificationModal'



class FeeDashBoardSection extends Component {
    constructor(props) {
        super(props)
        this.state = {

            branch: "",
            branchError: "",
            getStudentFeeDashboardDetails: [],
            studentsModal: false,
            studentsFeeData: [],
            tableType: "",
            getNoOfTermsForCollege: [],

            selectedTerm: 0,
            notificationModal: false,

            getTermWisePendingStudents: [],

            loaderforModal: 0,
            is_submitted: false

        }
    }

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;

        if (name == "branch") {
            this.setState({ branch: value, getNoOfTermsForCollege: [], getStudentFeeDashboardDetails: [], getTermWisePendingStudents: [], studentsFeeData: [], branchError: "",is_submitted:false })
        }
    };

    getStudentFeeDashboardDetails = async () => {


        if (this.state.branch == "") {
            this.setState({ branchError: "Please select Branch" });
            return "";
        }
        this.setState({ loader: 1 })
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int, $branch_id: Int){
                    getStudentFeeDashboardDetails(institute_id: $institute_id, branch_id: $branch_id) {
                      total_amount
                      paid_amount
                      pending_amount
                      overdue_amount
                      sectionWisePaymentData {
                        section_name
                        class_name
                        exam_name
                        total_amount
                        paid_amount
                        pending_amount
                        due_amount
                        due_students_count
                        pending_Students_count
			             due_student_data{
                            student_name
                            pending_amount
                            parent_mobile
                            due_amount
                        }
                        pending_student_data{
                            student_name
                            pending_amount
                            parent_mobile
                            due_amount
                        }
                      }
                    }
            }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch)
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getStudentFeeDashboardDetails.length > 0) {
            this.setState({ getStudentFeeDashboardDetails: result.data.getStudentFeeDashboardDetails, loader: 0 })
        } else {
            this.setState({ getStudentFeeDashboardDetails: [], loader: 0 })
        }

        const result2 = await this.props.client.query({
            query: gql`
            query($institute_id:Int, $branch_id:Int){
                getNoOfTermsForCollege(institute_id:$institute_id, branch_id:$branch_id){
                  term_no
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch)
            },
            fetchPolicy: 'network-only'
        })

        if (result2.data.getNoOfTermsForCollege.length > 0) {
            this.setState({
                getNoOfTermsForCollege: result2.data.getNoOfTermsForCollege
            })
        } else {
            this.setState({
                getNoOfTermsForCollege: [],
                is_submitted: true
            })
        }
    }

    Columns(data) {


        let Columns = [
            {
                dataField: "class_name",
                text: "Class",
            },
            {
                dataField: "exam_name",
                text: "Exam",
            },
            {
                dataField: "section_name",
                text: "Section",
            },
            {
                dataField: "pending_amount",
                text: "Pending Amount",
            },
            {
                dataField: "due_students_count",
                text: "No.Of.Students Due",
                sort: true,
                formatter: this.actionFormatter1.bind(this),
            },
            {
                dataField: "pending_Students_count",
                text: "No.Of.Students Pending",
                formatter: this.actionFormatter2.bind(this),
                sort: true
            },
        ];
        return Columns;
    }

    tableData(data) {
        let returnArray = []

        data.map((item) => {
            let newObj = {
                class_name: item.class_name,
                exam_name: item.exam_name,
                section_name: item.section_name,
                pending_amount: item.pending_amount.toLocaleString('en-IN'),
                due_students_count: item.due_students_count,
                pending_Students_count: item.pending_Students_count,
                due_student_data: item.due_student_data,
                pending_student_data: item.pending_student_data
            }
            returnArray.push(newObj)
        })
        return returnArray
    }

    actionFormatter1(cell, row, rowIndex, formatExtraData) {
        return (<>
            <a onClick={() => this.pendingStudentsModal(row.due_student_data, "due")}>
                <p style={{ color: "black", textDecoration: "underline" }}>{row["due_students_count"]}</p>
            </a>
        </>)
    }

    actionFormatter2(cell, row, rowIndex, formatExtraData) {
        return (<>
            <a onClick={() => this.pendingStudentsModal(row.pending_student_data, "pending")}>
                <p style={{ color: "black", textDecoration: "underline" }}>{row["pending_Students_count"]}</p>
            </a>
        </>)
    }

    pendingStudentsModal = (studentsData, tableType) => {
        this.setState({ studentsModal: true, studentsFeeData: studentsData, tableType: tableType })
    }

    sendNotificationModal = async (term) => {
        this.setState({
            notificationModal: true,
            selectedTerm: term,
        })

        this.setState({
            loaderforModal: 1
        })

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$term_no:Int){
                getTermWisePendingStudents(institute_id:$institute_id,branch_id:$branch_id,term_no:$term_no){
                    student_name
                    parent_mobile
                    term_date
                    term_amount
                  }
            }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch),
                term_no: parseInt(term)
            }
        })
        if (result.data.getTermWisePendingStudents.length > 0) {
            this.setState({
                getTermWisePendingStudents: result.data.getTermWisePendingStudents,
                loaderforModal: 0

            })
        } else {
            this.setState({
                getTermWisePendingStudents: [],
                loaderforModal: 0
            })
        }
    }

    render() {

        console.log("mahesh", this.state)
        return (
            <Container fluid>
                <Row>
                    <Col sm={12}>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranchName">
                                    <Form.Label className="text-uppercase">Branch</Form.Label>
                                    <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                        <option value={this.state.defaultvalue}>--Select Branch--</option>
                                        {this.props.globals.globalBranches.map(branchData => (
                                            <option value={branchData.id}>{branchData.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.branchError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                    <Button className="btn btn-success text-uppercase submit_btn" onClick={(e) => this.getStudentFeeDashboardDetails()}>Submit</Button>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Col>
                </Row>
                {
                    this.state.loader == 1 ?
                        (
                            <div className="spinner-border text-primary text-center loading-img-center"></div>
                        )
                        :
                        ("")
                }
                {
                    this.state.getStudentFeeDashboardDetails.length > 0 && this.state.getNoOfTermsForCollege.length > 0 ?
                        (
                            <>
                                <Row className="mt-3">
                                    <Col sm={12}>
                                        <h5>Want to Notify Parents ?</h5>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    {
                                        this.state.getNoOfTermsForCollege.map((item) => {
                                            return (
                                                <Col sm={2}>
                                                    <div className="notification_box" onClick={() => this.sendNotificationModal(item.term_no)}>
                                                        <h6 class="not_text">Term  {item.term_no}  Pending Students</h6>
                                                    </div>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                            </>
                        )
                        :
                        ("")
                }
                {
                    this.state.getStudentFeeDashboardDetails.length > 0 && this.state.getNoOfTermsForCollege.length > 0 ?
                        (
                            <>
                                <Row className="mt-5">
                                    <Col sm={3}>
                                        <Card className='each_card'>
                                            <Card.Body className="p-2">
                                                <Row>
                                                    <Col sm={12}>
                                                        <h5 className="text-center">Total Amount</h5>
                                                    </Col>
                                                </Row>
                                                <Card.Text className='description text-center f-18'>{this.state.getStudentFeeDashboardDetails[0]?.total_amount?.toLocaleString('en-IN')}</Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col sm={3}>
                                        <Card className='each_card'>
                                            <Card.Body className="p-2">
                                                <Row>
                                                    <Col sm={12}>
                                                        <h5 className="text-center">Paid Amount</h5>
                                                    </Col>
                                                </Row>
                                                <Card.Text className='description text-center f-18'>{this.state.getStudentFeeDashboardDetails[0]?.paid_amount?.toLocaleString('en-IN')}</Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col sm={3}>
                                        <Card className='each_card'>
                                            <Card.Body className="p-2">
                                                <Row>
                                                    <Col sm={12}>
                                                        <h5 className="text-center">Pending Amount</h5>
                                                    </Col>
                                                </Row>
                                                <Card.Text className='description text-center f-18'>{this.state.getStudentFeeDashboardDetails[0]?.pending_amount?.toLocaleString('en-IN')}</Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col sm={3}>
                                        <Card className='each_card'>
                                            <Card.Body className="p-2">
                                                <Row>
                                                    <Col sm={12}>
                                                        <h5 className="text-center">Overdue Amount</h5>
                                                    </Col>
                                                </Row>
                                                <Card.Text className='description text-center f-18'>{this.state.getStudentFeeDashboardDetails[0]?.overdue_amount?.toLocaleString('en-IN')}</Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                                <Row className="mt-5">
                                    <Col sm={12}>
                                        <h3 className="text-center">Section wise Pending Amount Data</h3>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col sm={12}>
                                        <CardLessDataTableWithOutSearch
                                            parentData={this.tableData(this.state.getStudentFeeDashboardDetails[0].sectionWisePaymentData)}
                                            particlecolumns={this.Columns()}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )
                        :
                        (

                            this.state.is_submitted ? (

                                <Row>
                                    <Col className="mt-5 text-center">
                                        <h6>No data found</h6>
                                    </Col>
                                </Row>
                            ) : ("")

                        )
                }
                <StudentsModal
                    show={this.state.studentsModal}
                    onHide={() => this.setState({ studentsModal: false })}
                    studentsFeeData={this.state.studentsFeeData}
                    tableType={this.state.tableType}
                />
                <NotificationModal
                    show={this.state.notificationModal}
                    onHide={() => this.setState({ notificationModal: false, selectedTerm: 0 })}
                    stateData={this.state}
                />
            </Container>
        )
    }
}

export default withRouter(withApollo(compose(

)(FeeDashBoardSection))
);